"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyContextMetaForNewReport = exports.LAST_UPDATED_CLIENT_PLACEHOLDER = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.LAST_UPDATED_CLIENT_PLACEHOLDER = 'last_updated_client_placeholder';
function copyContextMetaForNewReport(contextMeta) {
    if (lodash_1.default.isEmpty(contextMeta)) {
        return contextMeta;
    }
    var newContextMeta = lodash_1.default.cloneDeep(contextMeta);
    // indicate that the report was just copied and hasn't had any updates yet
    newContextMeta.lastUpdatedClientInstanceId = exports.LAST_UPDATED_CLIENT_PLACEHOLDER;
    // delete all public report info
    newContextMeta.isPublic = false;
    delete newContextMeta.publicHash;
    delete newContextMeta.passcodeProtected;
    delete newContextMeta.passcodeHash;
    // remove status indicating whether predefined data has been processed
    if (lodash_1.default.has(newContextMeta, 'predefined.status')) {
        delete newContextMeta.predefined.status;
    }
    return newContextMeta;
}
exports.copyContextMetaForNewReport = copyContextMetaForNewReport;
